export const getSpacingVar = <S extends string>(spacing: S) =>
    `var(--spacing-${spacing}, 32px)` as const;

export const Spacing = {
    md: getSpacingVar('md'),
    sm: getSpacingVar('sm'),
    xs: getSpacingVar('xs'),
    xxs: getSpacingVar('xxs'),
    xxxs: getSpacingVar('xxxs'),
} as const;

export type SpaceVariant = keyof typeof Spacing;
